<section style="" class="logo-brands-box">
  <div class="container-fluid">
    <div class="row ctsm-row">
      <h2 class="clients-text">Trusted by diverse range of clients,<br /> from Fortune 500 companies to small businesses
        and nonprofits </h2>
      <!-- <ion-slides></ion-slides> -->
      <ion-slides  class="ourclientsdata">
              
            
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=love-bonito">
                    <img loading="lazy" width="146" height="78" class="brand-logo-img" src="assets/images/home-new/lovebonito.png" alt="Love Bonito" title="lovebonito">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=HM">
                    <img loading="lazy" width="146" height="78" class="brand-logo-img" src="assets/images/home-new/H&M.png" alt="H&M"  title="H%26M">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=cynthia">
                    <img loading="lazy" width="146" height="78" class="brand-logo-img" src="assets/images/home-new/cynthiarowley.svg" alt="cynthia Rowley"   title="cynthiarowley">
                  </a>
                </div>
              </ion-slide>
              
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a routerLink="/portfolio.html">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/stc.png" alt="STC" title="stc">  
                  </a>
                </div>
              </ion-slide>
             
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=ramybrook">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/ramybrook.png" alt="Ramy Brook" title="ramybrook">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=calvinkleinkorea">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/Calvin-Klein-logo.png" alt="Calvin-Klein" title="calvinkleinkorea">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=neemlinaturals">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/neemli.png" alt="neemli naturals" title="neemli">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=truebrowns">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/truebrowns.png" alt="true browns" title="truebrowns">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=thelabellife">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/labelife.png" alt="label life" title="labelife">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=abhishti">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/abhishti-store.png" alt="abhishti store" title="abhishti-store">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=BODYARMOR">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/bodyarmor.png" alt="bodyarmor" title="bodyarmor">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=voylla">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/voylla.png" alt="Voylla" title="voylla">
                  </a>
                </div>
              </ion-slide>
          
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=4cabling">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/4cabling.png" alt="4 Cabling" title="4cabling">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=petandjoys">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/PetsandjoysLogo.svg" title="PetsandjoysLogo" alt="Petsandjoys">  
                  </a>
                </div>
              </ion-slide>

              <ion-slide>
                <div class="slide logo-brands-row">
                  <a routerLink="/portfolio.html">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/jaipurrugs.svg" alt="Jaipur Rugs" title="jaipurrugs">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=supplyOk">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/supplyok.png" alt="Supplyok" title="Supplyok">
                  </a>
                </div>
              </ion-slide>
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="https://www.salon24.pl/" target="_blank">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/salon-logo.png" alt="salon" title="salon-logo">
                  </a>
                </div>
              </ion-slide>
              
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=ilastword">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/ilastword.png" alt="iLastword" title="ilastword">
                  </a>
                </div>
              </ion-slide>
    
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=threndx">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/threndx.png" alt="Threndx" title="threndx">
                  </a>
                </div>
              </ion-slide>
    
              
              
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=zonsteps">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/zonsteps.png" title="zonsteps" alt="ZonSteps">  
                  </a>
                </div>
              </ion-slide>
              
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=lockwood">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/lockwood.png" alt="Lockwood" title="lockwood">                 
                  </a>
                </div>
              </ion-slide>
              
              
              
              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=marcfisher">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/marcfisher.png" alt="marcfisher" title="marcfisher">
                  </a>
                </div>
              </ion-slide>
            
              
  
              

              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="/portfolio-detail?value=thehomeentrepreneurs">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/home-new/the.png" alt="The Home Entrepreneurs" title="thehomeentrepreneurs">
                  </a>
                </div>
              </ion-slide>

              
              
              

             

              <ion-slide>
                <div class="slide logo-brands-row">
                  <a href="https://www.catholicnewsagency.com/" target="_blank">
                    <img width="146" height="78" class="brand-logo-img" src="assets/images/logo-red-black-small.png?alt" alt="logo-red-black-small" name="logo-red-black-small" title="logo-red-black-small">
                  </a>
                </div>
              </ion-slide>

              

              
              
            </ion-slides>
            
   
        <div class=" row partner-logo-section-row partner-logo-section-row-desktop">
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a routerLink="/portfolio.html" name="syska" title="syska" >
            <div>
              <i class="icon-partners syska"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=love-bonito" name="love-bonito" title="love-bonito" >
            <div>
              <i class="icon-partners lovebonito"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=HM" name="HM" title="HM">
            <div>
              <i class="icon-partners HM  "></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=vans" name="vans" title="vans">
            <div>
              <i class="icon-partners vanslogo"></i>
            </div>
          </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a routerLink="/portfolio.html"  name="stc" title="stc">
            <div>
              <i class="icon-partners stc"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=rungg-shoes" name="rungg-shoes" title="rungg-shoes">
            <div>
              <i class="icon-partners rungglogo"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=ramybrook" name="ramybrook" title="ramybrook">
            <div>
              <i class="icon-partners ramybrook "></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=calvinkleinkorea" name="calvinkleinkorea" title="calvinkleinkorea">
            <div>
              <i class="icon-partners Calvin-Klein-logo"></i>
            </div>
          </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=neemlinaturals" name="neemlinaturals" title="neemlinaturals">
            <div>
              <i class="icon-partners neemli"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=truebrowns" name="truebrowns" title="truebrowns">
            <div>
              <i class="icon-partners truebrowns"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=thelabellife" name="thelabellife" title="thelabellife">
            <div>
              <i class="icon-partners labelife"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=abhishti" name="abhishti" title="abhishti">
            <div>
              <i class="icon-partners abhishti-store"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=BODYARMOR" name="BODYARMOR" title="BODYARMOR">
            <div>
              <i class="icon-partners bodyarmor  "></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=voylla" name="voylla" title="voylla">
            <div>
              <i class="icon-partners voylla"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=bamboonature" name="bamboonature" title="bamboonature">
            <div>
              <i class="icon-partners bambo-nature "></i>
            </div>
          </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=4cabling" name="4cabling" title="4cabling">
            <div>
              <i class="icon-partners cabling "></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=petandjoys" name="petandjoys" title="petandjoys">
            <div>
              <i class="icon-partners PetsandjoysLogo"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=supplyOk" name="supplyOk" title="supplyOk">
            <div>
              <i class="icon-partners supplyok"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="https://www.salon24.pl/" target="_blank" name="salon24" title="salon24">
            <div>
              <i class="icon-partners salon-logo"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=ilastword" name="ilastword" title="ilastword">
            <div>
              <i class="icon-partners ilastword "></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=threndx" name="threndx" title="threndx">
            <div>
              <i class="icon-partners threndx"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=zonsteps" name="zonsteps" title="zonsteps">
            <div>
              <i class="icon-partners zonsteps"></i>
            </div>
          </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=lockwood" name="lockwood" title="lockwood">
            <div>
              <i class="icon-partners lockwood"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=marcfisher" name="marcfisher" title="marcfisher">
            <div>
              <i class="icon-partners marcfisher"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=allprocolor" name="allprocolor" title="allprocolor">
            <div>
              <i class="icon-partners allprocolor  "></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="/portfolio-detail?value=thehomeentrepreneurs" name="thehomeentrepreneurs" title="thehomeentrepreneurs">
            <div>
              <i class="icon-partners the"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a routerLink="/portfolio.html" name="champ_buddy_logo" title="champ_buddy_logo">
            <div>
              <i class="icon-partners champ_buddy_logo"></i>
            </div>
            </a>
          </div>
          <div class="col-xs-6 col-md-4 partner-logo-section">
            <a href="https://www.catholicnewsagency.com/" target="_blank" name="catholicnewsagency" title="catholicnewsagency">
            <div>
              <i class="icon-partners logo-red-black-small"></i>
            </div>
          </a>
          </div>
        
      </div>
    </div>
  </div>
</section>